import { useState, useEffect, useRef, React } from 'react';
// import logo from './logo.svg';
import '../App.css';
import {Dot, Orientation} from './Dot';
import { GlobalNoContext } from './Global';


function DotsGame() {
  let [dotNo, setDotNo] = useState(1);

  const [dots, setDots] = useState([]);
  if (dots.length === 0) {
    setDots([<Dot/>])
  }
  // setDots([<Dot/>])
  // const containerRef = useRef(null);

  const addDot = () => {
      setDots([...dots, <Dot/>]);
  };

  // useEffect(() => {
  //     // 这里不需要手动操作appendChild，React会根据状态变化自动更新DOM
  // }, [dots]);

  return (
    <GlobalNoContext.Provider value={{dotNo, setDotNo}}>
      <div>
        <Orientation/>
        <div id="nemu">
          <button onClick={addDot}>Add Dot</button>
        </div>
        <div>
          {dots}
        </div>
      </div>
    </GlobalNoContext.Provider>
  );
}

export default DotsGame;
